import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useContext } from 'react';
import { FormattedNumber as IntlFormattedNumber, IntlProvider, useIntl } from 'react-intl';
import LocalizationContext from "../LocalizationProvider/LocalizationContext";
export default function FormattedNumber(props) {
  var _useContext = useContext(LocalizationContext),
      preferences = _useContext.preferences;

  var parentIntl = useIntl();

  if (preferences !== null && preferences !== void 0 && preferences.locale) {
    return React.createElement(IntlProvider, {
      locale: preferences.locale,
      messages: {},
      formats: parentIntl.formats,
      onError: parentIntl.onError
    }, React.createElement(IntlFormattedNumber, props));
  }

  return React.createElement(IntlFormattedNumber, _extends({}, props, {
    "data-qa": "formatted-number"
  }));
}